import cookie from 'react-cookies';
export const getAutoFillCookieInfo = (key) =>{
    const cookieValue = cookie.load(key);
    if(cookieValue){
        return cookieValue === 'false' ? false : true;
    }
    else{
        return false;
    }
}